module.exports = __webpack_public_path__ + "static/to-do-list-06d6f78591e32dca9d4bca38f1a6fe58.png";